module.exports = __webpack_public_path__ + "src/assets/img/ottplatform.c4c096cd.jpg";